<template>
  <TopBar />

  <section id="breadcrumbs" class="breadcrumbs">
    <div class="container">
      <div class="col-lg-12">
      <ol>
        <li class="text-danger"><a href="/">Início</a></li>
      </ol>
      <h2>Política de Privacidades e Cookies</h2>
      </div>
    </div>
  </section>
  <!-- End Breadcrumbs -->

  <section class="inner-page mt-5">
    <div class="container">
      <div class="col-lg-12">
      <p>
        <b>Identificação do Controlador de Dados: <br>
        <br> </b>
        CREDITALL GESTÃO E GARANTIA DE CRÉDITO LTDA, pessoa jurídica de direito privado, inscrita no CNPJ sob o nº 11.927.349/0001-90, com sede na Rua 14 de Dezembro, 45, Sobreloja, Bairro Vila Bernardino Bogo, CEP 87160-000, Mandaguaçu-PR.<br>
        <br>
        A presente política de privacidade se aplica a todas as informações pessoais coletadas por nossos sistemas e colaboradores, seja off-line ou on-line e tem por objetivo trazer transparência ao titular de dados de como tratamos os dados pessoais dentro da organização, respeitando seus direitos e as obrigações legais previstas na Lei 13.709/2018 – LGPD.
        </p>

            <div class="card">
              <div class="card-header" id="headingRef">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseRef" aria-expanded="false" aria-controls="collapseTwo">
                    Definições e referências jurídicas
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseRef" class="collapse" aria-labelledby="headingRef" data-parent="#accordion">
                <div class="card-body">
                    <p>
                      <strong>Titular de Dados:</strong> As pessoas físicas cujos dados pessoais tratados.<br>
                      <br><strong>Dados pessoais:</strong> Informações fornecidas e/ou coletadas pela Creditall, que identificam ou seja capaz de identificar uma pessoa natural;<br>
                      <br><strong>Finalidade:</strong> É o propósito legítimo para o qual a Creditall coleta e trata os dados pessoais.<br>
                      <br><strong>bases legais:</strong> Fundamentação legal que torna legítimo e possível o tratamento de dados pessoais para as finalidades propostas pela organização. E a hipótese de tratamento de dados eleita pela organização dentre as possíveis trazidas pela LGPD.<br>
                      <br><strong>Consentimento:</strong> Autorização expressa, específica e inequívoca dada pelo titular do dado pessoal para que a Creditall trate seus dados pessoais para as finalidades previamente descritas, com base legal elencada.<br>
                      <br><strong>Controlador:</strong> Aquele a quem compete as decisões referentes ao tratamento dos dados pessoais.<br>
                      <br><strong>Operador:</strong> Aquele que efetua o tratamento dos dados pessoais em nome do controlador.<br>
                      <br><strong>encarregado:</strong> Aquele que serve como canal de comunicação entre o controlador, os usuários e a Autoridade Nacional de Proteção de Dados - ANPD;<br>
                      <br><strong>Tratamento:</strong> Toda e qualquer ação, conduta ou operação realizada com os dados pessoais, como a coleta, utilização, transmissão, armazenamento etc<br>
                      <br><strong>Anonimização:</strong> Uso de meios técnicos para fazer com que um dado pessoal perca a possibilidade de associação ou identificação a uma pessoa física.<br>
                      <br><strong>Eliminação:</strong> Exclusão definitiva e irrecuperável dos dados fornecidos.
                    </p>
                </div>
              </div>
            </div>
      
          <div id="accordion">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h5 class="mb-0">
                  <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Dados Pessoais 
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>

              <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body">
                    <p>
                      <strong>Como coletamos os dados pessoais? Quais dados? Para qual finalidade? Qual hipótese legal de tratamento?</strong><br> 
                      <br>Primeiro gostaríamos de esclarecer que em nossa atividade comercial trabalhamos como operador de dados para comerciantes – controladores de dados – que coletam seus dados quando realizam negócio com você.<br>
                      <br>
                      Abaixo explicaremos quais dados nosso sistema solicita para que seu fornecedor preencha e para qual finalidade para assim podemos lhe auxiliar em compras parceladas.
                    </p>
                    
                    <table class="dados-tabela">
                      <thead>
                        <tr>
                          <th>ORIGEM</th>
                          <th>DADOS</th>
                          <th>FINALIDADE</th>
                          <th>BASE LEGAL</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Comerciante - Cliente Creditall<br><b>Controlador de dados</b></td>
                          <td>
                            <ul style="padding-left: 18px; margin: 0;">
                            <li>Nome</li>
                            <li>Endereço</li>
                            <li>E-mail</li>
                            <li>Telefone</li>
                            <li>Celular</li>
                            <li>CPF</li>
                            <li>Nº da compra</li>
                            <li>Mobiliaria</li>
                            <li>Valor da garantia</li>
                            <li>imovel locado</li>
                          </ul>
                          </td>
                          <td>Concessão de Fiança Locatica</td>
                          <td>Execução de Contratos.<br>Exercicio regular do Direito.</td>
                        </tr>
                        <tr>
                          <td>Comerciante - Cliente Credital<br><b>Controlador de Dados</b></td>
                          <td>
                        <ul style="padding-left: 18px; margin: 0;">
                          <li>Nome</li>
                          <li>CPF</li>
                          <li>Valor a ser pago</li>
                          <li>Nº da compra</li>
                          <li>Data do pagamento</li>
                          <li>Data do vencimento</li>
                          <li>Nome da loja que comprou</li>
                        </ul>
                      </td>
                      <td>Faturamento</td>
                      <td>Execução de Contratos</td>
                        </tr>
                        <tr>
                          <td>Portal Maringa.com</td>
                          <td>
                            <ul style="padding-left: 18px; margin: 0;">
                              <li>Nome</li>
                              <li>Endereço</li>
                              <li>Telefone</li>
                              <li>Idade</li>
                              <li>Estado Civil</li>
                              <li>Informações sobre filhos</li>
                              <li>Avaliações</li>
                            </ul>
                          </td>
                          <td>Recrutamento e Seleção de pessoal</td>
                          <td>Preliminar de Contrato</td>
                        </tr>
                        <tr>
                          <td>Comerciante - Cliente credital<br><b>Controlador de dados</b></td>
                          <td>
                            <ul style="padding-left: 18px; margin: 0;">
                              <li>Nome</li>
                              <li>CPF</li>
                              <li>Endereço</li>
                              <li>Telefone</li>
                              <li>E-mail</li>
                              <li>Data de nascimento</li>
                              <li>Dados bancarios</li>
                              <li>Telefone recado</li>
                              <li>Documento com foto</li>
                            </ul>
                          </td>
                          <td>Cadastro do titular de dados -<br><b>consumidor do comerciante para<br> prestar suporte e evitar fraudes com divêrgencias</b></td>
                          <td>Execução de contratos</td>
                        </tr>
                        <tr>
                          <td>Titular de Dados</td>
                          <td>
                            <ul style="padding-left: 18px; margin: 0;">
                              <li>CPF</li>
                              <li>Telefone</li>
                              <li>Comprovante de endereço</li>
                            </ul>
                          </td>
                          <td>Alteração de dado cadastral</td>
                          <td>Execução de contratos</td>
                        </tr>
                        <tr>
                          <td>E-mail, whatsapp</td>
                          <td>
                            <ul style="padding-left: 18px; margin: 0;">
                              <li>Nome</li>
                              <li>CPF</li>
                              <li>Chave pix</li>
                              <li>Dados bancarios</li>
                            </ul>
                          </td>
                          <td>Alteração de dado cadastral</td>
                          <td>Execução de contratos</td>
                        </tr>
                        <tr>
                          <td>Registro de colaborador</td>
                          <td>
                            <ul style="padding-left: 18px; margin: 0;">
                              <li>Dados pessoais de admissão</li>
                            </ul>
                          </td>
                          <td>Registro de administração de pessoal</td>
                          <td>Obrigação legal</td>
                        </tr>
                      </tbody>
                    </table>
                </div>
              </div>
            </div>


            <div class="card">
              <div class="card-header" id="headingTwo">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Segurança
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                <div class="card-body">
                    <p>
                       Nós empregamos medidas organizacionais, técnicas e administrativas adequadas para proteger as Informações Pessoais sob nosso controle, como backup diário de dados e gestão e monitoramento de riscos. Porém, infelizmente, nenhuma transmissão de dados pela Internet ou sistema de armazenamento de dados digital pode ser garantida como sendo 100% segura.<br> 
                      <br>
                      Se você tiver motivos para acreditar que a sua interação conosco tenha deixado de ser segura ou tenha sido comprometida, por favor, nos contate imediatamente, entrando em contato com nosso Encarregado de Tratamento de Dados, abaixo identificados.
                    </p>
                </div>
              </div>
            </div>

            <!-- <div class="card">
              <div class="card-header" id="headingThree">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Operador
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                    <p>
                      Para melhor compreensão, destacamos os conceitos trazidos pela LGPD, a respeito:<br>
                      <br>
                    <strong>Controlador: </strong> A quem competem as decisões referentes ao Tratamento de Dados Pessoais, especialmente relativas às finalidades e aos meios de tratamento.<br>
                    <br>
                    <strong>Operador: </strong> Pessoa jurídica ou física, distinta do controlador, que trata Dados Pessoais de acordo com as instruções do Controlador. São terceirizados contratados pelo Controlador.
                    </p>
                </div>
              </div>
            </div>-->

          <!-- <div class="card">
              <div class="card-header" id="headingFour">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Cookies
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                <div class="card-body">
                    <p>
                      Um cookie é um pequeno fragmento de dados que nosso site armazena em seu navegador e que contém algumas informações sobre você, como sua preferência de idioma ou informações de login. Em uma nova visita, seu navegador nos envia este fragmento de volta para podermos fornecer uma experiência de navegação mais personalizada. Essas informações são usadas principalmente para que o site funcione como você espera e geralmente não o identificam diretamente.
                    </p>
                    <p>
                      Quando você realiza um cadastro no sistema Creditall, nos estabelecimentos conveniados, são coletados os seguintes dados:
                      <br>
                    </p>
                    <b>Dados Coletados:</b>
                    <ul>
                      <li>a) Nome;</li>
                      <li>b) CPF;</li>
                      <li>c) E-mail;</li>
                      <li>d) Telefone e nome de recado;</li>
                      <li>e) Endereço;</li>
                    </ul>
                </div>
              </div>
            </div> -->

            <div class="card">
              <div class="card-header" id="headingSix">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    Compartilhamento
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordion">
                <div class="card-body">
                    <p>
                      A depender da finalidade para qual o dado pessoal é tratado, compartilhamos o mesmo com nossos parceiros de negócios - operadores de dados, todos comprometidos através de contratos firmados a cumprir as exigências da Lei Geral de Proteção de Dados e da presente política.<br>
                      Para melhor compreensão, destacamos os conceitos trazidos pela LGPD, a respeito:<br>
                      <br>
                      <strong>Controlador:</strong> A quem competem as decisões referentes ao Tratamento de Dados Pessoais, especialmente relativas às finalidades e aos meios de tratamento.<br>
                      <strong>Operador:</strong> pessoa jurídica ou física, distinta do controlador, que trata Dados Pessoais de acordo com as instruções do Controlador. São terceirizados contratados pelo Controlador.<br>
                      <br>
                      <strong>Instituições:</strong> Financeiras para processamento de meios de pagamento: somos parceiros do Bradesco, Banco do Brasil, Banrisul, Santander, Itau, Pagseguro e Sicoob.
                      <strong>Convenios de beneficios:</strong> Ticket S/A, TCCC, Humana Saúde e Viação Garcia.<br>
                      <strong>Autoridades públicas:</strong> Temos de cumprir a lei. Assim, existem leis que nos obrigam compartilhamento de determinados dados com autoridades públicas, como a Receita Federal, INSS, o portal do E-Social, Polícia Federal e Ministério da Agricultura. Além da possibilidade de uma autoridade fiscalizatória ou judicial nos exigir compartilhamento de determinados dados pessoais para, por exemplo, uma investigação criminal.<br>
                      <strong>Medicina e Segurança do trabalho:</strong> Conecty Saúde.
                    </p>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header" id="headingSeven">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                    Transferência Internacional de Dados
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordion">
                <div class="card-body">
                    <p>
                      Alguns dados são armazenados em nossa nuvem contratada com a Microsoft e a Uol Host, que possui hospedagem internacional localizada nos Estados Unidos da América, país com nível de segurança em proteção de dados reconhecido e cuja política de privacidade e níveis de segurança podem ser verificados aqui
                      <b><a href="https://sobreuol.noticias.uol.com.br/normas-de-seguranca-e-privacidade" target="_blank" style="color: crimson;">UolCloud</a></b> e
                      <b><a href="https://privacy.microsoft.com/pt-br/privacystatement" target="_blank" style="color: crimson;">Microsoft</a></b>.
                    </p>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header" id="headingEight">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                    Período De Retenção
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordion">
                <div class="card-body">
                    <p>
                        Nós manteremos o tratamento dos dados pessoais somente enquanto perdurar a finalidade declarada, por uma obrigação legal ou regulamentar, para o exercício regular de direito (em caso de defesas judiciais, administrativas ou em processo arbitral) ou quando válido o consentimento dado, sendo resguardados sob a égide de nossos sistemas de segurança.
                    </p>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header" id="headingNine">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                    Direito dos Titulares de dados
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordion">
                <div class="card-body">
                  <p>Você tem os seguintes direitos em relação aos seus dados pessoais:</p>
                  <ul style="list-style-type: disc; padding-left: 20px;">
                    <li><b>Obter</b> confirmação da existencia do tratamento.</li>
                    <li><b>Acesso</b> aos dados tratados.</li>
                    <li><b>Correção</b> ou atualização do dado.</li>
                    <li><b>Anonimização, bloqueio ou eliminação</b> dos dados desnecessários.</li>
                    <li><b>Portabilidade</b> dos dados a outro fornecedor.</li>
                    <li><b>Revogação</b> do próprio consentimento.</li>
                    <li>Informação sobre o <b>compartilhamento</b> dos seus dados.</li>
                    <li>Informação sobre o não <b>consentimento</b> e suas <b>consequencias.</b> </li>
                    <li><b>Eliminação</b> dos dados pessoais tratados com o consentimento.</li>
                    <li><b>Revisão</b> das decisões automatizadas.</li>
                  </ul>
                  <p>O Titular pode fazer as solicitações listadas acima entrando em contato com o nosso Encarregado de Tratamento de Dados por meio do e-mail <a href="mailto:contato@creditall.com.br">contato@creditall.com.br</a>. ou através de nosso formulário digital nos nossos sites, os quais serão respondidos em até 15 dias.</p>
                </div>
              </div>
            </div>

              <div class="card">
              <div class="card-header" id="headingThree">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Responsabilidade
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                    <p>
                      Como controladores de seus dados, nós nos responsabilizamos por tratá-los na forma declarada nesta política, bem como nos termos da Lei Geral de Proteção de Dados, respondendo por toda e qualquer conduta contrária à LGPD realizada por nós ou por nossos operadores de dados, que resulte em danos ao titular de dados, desde que não causado por culpa do próprio titular ou de terceiros.<br>
                      <br>
                      Todo e qualquer incidente de segurança será registrado e relatado, e caso necessário comunicado à ANPD e aos titulares de dados envolvidos com o Relatório de Impacto, a prestação de contas e a reparação pertinente.<br>
                      <br>
                      Para nos ajudar a evitar tais incidentes, recomendamos a adoção de boas práticas de segurança em relação aos seus dados (como, por exemplo, não compartilhar senhas com terceiros), e caso você identifique ou tome conhecimento de algo que comprometa a segurança dos seus dados, por favor entre imediatamente em contato conosco por meio do nosso Encarregado (Data Protection Officer), cujos canais de contato se encontram abaixo.
                    </p>
                </div>
              </div>
            </div>

                        <div class="card">
              <div class="card-header" id="headingAcess">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseAcess" aria-expanded="false" aria-controls="collapseAcess">
                    Canal de acesso
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseAcess" class="collapse" aria-labelledby="headingEight" data-parent="#accordion">
                <div class="card-body">
                    <p>
                        A fim de requerer quaisquer dos direitos acima listados, como revisar, corrigir, atualizar, suprimir e apagar seus dados pessoais, sem qualquer custo, por favor, contatar nossa Encarregada de Tratamento de Dados: Raquel Cunha, que o responderá no prazo de 15 (quinze) dias úteis, através dos seguintes meios de comunicação:<br>
                        <br>
                        <b>E-mail:</b> <a href="mailto:contato@creditall.com.br">contato@creditall.com.br</a>
                    </p>
                </div>
              </div>
            </div>

           <!-- <div class="card">
              <div class="card-header" id="headingTen">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                    Política de Cookies
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </h5>
              </div>
              <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordion">
                <div class="card-body">
                    <p><b>O que são cookies?</b></p>
                    <p>
                      Como é prática comum em quase todos os sites profissionais, este site usa cookies, que são pequenos arquivos baixados no seu computador, para melhorar sua experiência. 
                      Esta página descreve quais informações eles coletam, como as usamos e por que às vezes precisamos armazenar esses cookies. Também compartilharemos como você pode impedir que esses cookies sejam armazenados, no entanto, isso pode fazer o downgrade ou ‘quebrar’ certos elementos da funcionalidade do site.
                    </p>
                    <br>
                    <p><b>Como usamos os cookies?</b></p>
                    <p>
                      Utilizamos cookies por vários motivos, detalhados abaixo. Infelizmente, na maioria dos casos, não existem opções padrão do setor para desativar os cookies sem desativar completamente a funcionalidade e os recursos que eles adicionam a este site. É recomendável que você deixe todos os cookies se não tiver certeza se precisa ou não deles, caso sejam usados para fornecer um serviço que você usa.
                    </p>
                    <br>
                    <p><b>Desativar cookies</b></p>
                    <p>Automaticamente deixamos todos os cookies não necessários e que dependem do seu consentimento (opt-in) desativados.</p>
                    <p>
                      Dessa forma, você pode configurá-los ajustando as configurações do seu navegador (conforme a finalidade de cada um, descrita em nosso cardápio). Esteja ciente de que a desativação de cookies afetará a funcionalidade deste e de muitos outros sites que você visita. A desativação de cookies geralmente resultará na desativação de determinadas funcionalidades e recursos deste site. Portanto, é recomendável que você ative-os.
                    </p>
                    <br>
                    <p><b>Cookies que definimos</b></p>
                    <ul>
                      <li>
                        <b>Cookies relacionados ao login</b>
                        <p>Utilizamos cookies quando você está logado, para que possamos lembrar dessa ação. Ele coleta seus dados de login e sub-login com a finalidade de manter ativa a conexão do usuário. Isso evita que você precise fazer login sempre que visitar uma nova página. Esses cookies são normalmente removidos ou limpos quando você efetua logout para garantir que você possa acessar apenas a recursos e áreas restritas ao efetuar login.</p>
                      </li>
                      <li>
                        <b>Cookies de Terceiros:</b>
                        <p>
                          Em alguns casos especiais, também usamos cookies fornecidos por terceiros confiáveis. A seção a seguir detalha quais cookies de terceiros você pode encontrar através deste site.
                        </p>
                        <p>
                          Este site usa o Google Analytics, que é uma das soluções de análise mais difundidas e confiáveis da Web, para nos ajudar a entender como você usa o site e como podemos melhorar sua experiência. Esses cookies podem rastrear itens como quanto tempo você gasta no site e as páginas visitadas, para que possamos continuar produzindo conteúdo atraente. Para mais informações sobre cookies do Google Analytics, consulte a página oficial do Google Analytics.
                          Também utilizamos o cookie Cloudflare, que coleta dados de localização do usuário (IP), apenas para validação de região/país, a fim de evitar ataques DDoS.
                        </p>
                        <p>
                          Por fim, também fazemos uso do UNPKG, que não coleta qualquer dado pessoal dos usuários.
                        </p>
                      </li>
                    </ul>
                </div>
              </div>
            </div> -->
       
          </div>
          <br><br>
          <p>
            <strong>ATUALIZAÇÕES DESTA POLÍTICA</strong>
            <br>
            Nós podemos modificar esta Política de Privacidade a qualquer momento.
            <br>
            <br>Quaisquer alterações a esta Política de Privacidade se tornarão vigentes quando a publicarmos revisada em nosso site.<br>
            <br>A utilização do site por você após tais alterações significa que você está ciente e aceita a Política de Privacidade revisada.

          </p>
          <p style="display: flex; justify-content: flex-end;">Mandaguaçu-PR, 11 de julho de 2025.   </p>
      </div>
    </div>
<div style="margin-top: 75px"></div>

  </section>
  <Footer />
</template>

<script>
import Footer from "../components/Footer.vue";
import TopBar from "../components/TopBar.vue";

export default {
  name: "PoliticasPrivacidades",
  components: {
    TopBar,
    Footer,
  },
};
</script>

<style scoped>
.btn-link {
    font-weight: 400;
    color: #444444;
    text-decoration:none;
}

.breadcrumbs {
  padding: 45px 0;
  margin-top: 4rem;
  background: #efefef;
}
@media only screen and (max-width: 320px) {
  .breadcrumbs {
    position: relative;
    width: 100%;
    margin-top: 44px;
  }
}

@media only screen and (min-width: 321px) and (max-width: 768px) {
  .breadcrumbs {
    position: relative;
    width: 100%;
    margin-top: 44px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumbs {
    position: relative;
    width: 100%;
    margin-top: 44px;
  }
}

.breadcrumbs h2 {
  font-size: 26px;
  font-weight: 600;
}
.breadcrumbs ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0 0 10px 0;
  margin: 0;
  font-size: 14px;
}
.breadcrumbs ol li + li {
  padding-left: 10px;
}
.breadcrumbs ol li + li::before {
  display: inline-block;
  padding-right: 10px;
  color: #333333;
  content: "/";
}

.accordion-button:not(.collapsed) {
  color: #444444;
  background-color: #e4e4e4;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

.dados-tabela {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 13px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
  table-layout: fixed;
}

.dados-tabela th, .dados-tabela td {
  padding: 1px 3px;         /* Menos espaço ainda */
  text-align: center;
  vertical-align: middle;
  border: 1px solid #e0e0e0;
  word-break: break-word;
  font-size: 11px;
  line-height: 1;           /* Linhas ainda mais compactas */
}

.dados-tabela ul {
  padding-left: 10px !important;
  margin: 0 !important;
}

.dados-tabela li {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
}

</style>
